import { render, staticRenderFns } from "./orderInvoices.pug?vue&type=template&id=67058009&scoped=true&lang=pug&"
import script from "./orderInvoices.ts?vue&type=script&lang=ts&"
export * from "./orderInvoices.ts?vue&type=script&lang=ts&"
import style0 from "./orderInvoices.scss?vue&type=style&index=0&id=67058009&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67058009",
  null
  
)

export default component.exports